module.exports = "pegasus/assets/tech/small/6.jpg";